import { Flex } from '@chakra-ui/react';
import React from 'react';
import './CustomErrorMessage.scss';

interface CustomErrorMessageProps {
  errorMessage: string;
}

const CustomErrorMessage = ({ errorMessage }: CustomErrorMessageProps) => {
  return <Flex className={'custom-error-message'}>{errorMessage}</Flex>;
};

export default CustomErrorMessage;
